import Vue from 'vue'
import VueRouter from 'vue-router'
import Minimal from '@/layouts/Minimal'
import Platform from '@/layouts/Platform'

Vue.use(VueRouter)


const routes = [
    {
        path: '/',
        component: Minimal,
        children: [{
            path: '',
            name: 'signinIndex',
            component: () => import('../views/Index.vue'),
            meta: { helpKey: "signin" }
        }]
    },

    {
        path: '/signin',
        component: Minimal,
        children: [{
            path: '',
            meta: { helpKey: "signin" },
            component: () => import('../views/Index.vue')
        }, {
            path: 'validate',
            meta: { helpKey: "signin" },
            component: () => import('../views/SignInValidate.vue')
        }]
    },

    {
        path: '/signout',
        component: Minimal,
        children: [{
            path: '',
            meta: { helpKey: "signout" },
            component: () => import('../views/Signout.vue')
        }]
    },

    {
        path: '/quotes',
        component: Platform,
        children: [{
            path: '',
            meta: { helpKey: "quoteList" },
            component: () => import('../views/quotes/Index.vue')
        }, {
            path: ':id',
            meta: { helpKey: "quoteSingle" },
            component: () => import('../views/quotes/Read.vue')
        }, {
            path: ':id/edit',
            meta: { helpKey: "quoteEdit" },
            component: () => import('../views/quotes/Edit.vue')
        }]
    },

    {
        path: '/rfqs',
        component: Platform,
        children: [{
            path: '',
            meta: { helpKey: "rfqList" },
            component: () => import('../views/rfqs/Index.vue')
        },{
            path: ':id',
            meta: { helpKey: "rfqSingle" },
            component: () => import('../views/rfqs/Edit.vue')
        },
        {
            path: ':id/:link_id/:code',
            meta: { helpKey: "publicRfqEdit" },
            component: () => import('../views/public_rfqs/Edit.vue'),
            name: 'publicRFQs',
        }]
    },

    {
        path: '/files',
        component: Platform,
        children: [
        {
            path: '',
            meta: { helpKey: "FilesIndex" },
            component: () => import('../views/files/Index.vue'),
            name: 'Files',
        }]
    },

    {
        path: '*',
        component: Platform,
        children: [{
            path: '*',
            meta: { helpKey: "error404" },
            component: () => import('../views/errors/404.vue')
        }]
    }
]

const router = new VueRouter({
    routes
})

export default router
